// Apps
export const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV ?? process.env.APP_ENV
export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL

// APIs
export const ALERTS_API_ENDPOINT = process.env.NEXT_PUBLIC_ALERTS_API_ENDPOINT
export const IAM_API_ENDPOINT = process.env.NEXT_PUBLIC_IAM_API_ENDPOINT
export const MAESTRO_BASE_URL = process.env.NEXT_PUBLIC_MAESTRO_BASE_URL
export const NEW_CLIENTS_API_ENDPOINT = process.env.NEXT_PUBLIC_NEW_CLIENTS_API_ENDPOINT
export const PRODUCT_API_BASE_URL = process.env.NEXT_PUBLIC_PRODUCT_API_BASE_URL
export const VISUALIZATION_API_ENDPOINT =
  process.env.NEXT_PUBLIC_VISUALIZATION_API_ENDPOINT
export const SLIDES_API_URL = process.env.NEXT_PUBLIC_SLIDES_API
export const BFF_API_URL = process.env.NEXT_PUBLIC_BFF_API

// Google
export const GOOGLE_TAG_MANAGER_KEY = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_KEY
export const GOOGLE_ANALYTICS_ID = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID

// Embeddable
export const EMBEDDABLE_API_KEY = process.env.NEXT_PUBLIC_EMBEDDABLE_API_KEY
export const EMBEDDABLE_BASE_URL = process.env.NEXT_PUBLIC_EMBEDDABLE_BASE_URL

// Amplitude
export const AMPLITUDE_API_KEY = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY

// Tolgee
export const TOLGEE_API_URL = process.env.NEXT_PUBLIC_TOLGEE_API_URL
export const TOLGEE_API_KEY = process.env.NEXT_PUBLIC_TOLGEE_API_KEY
export const TOLGEE_PROJECT_ID = process.env.NEXT_PUBLIC_TOLGEE_PROJECT_ID

// Cube
export const CUBE_API_URL = process.env.NEXT_PUBLIC_CUBE_API_URL

// Grafana
export const FARO_URL = process.env.NEXT_PUBLIC_FARO_URL
export const FARO_APP_NAME = process.env.NEXT_PUBLIC_FARO_APP_NAME

// Instatus
export const INSTATUS_PAGE_URL = process.env.NEXT_PUBLIC_INSTATUS_PAGE_URL

// App Envs
export const APP_ENVS = {
  LOCAL: 'local',
  DEVELOPMENT: 'development',
  PREVIEW: 'preview',
  PRODUCTION: 'production',
}

// Vercel bypass key
export const VERCEL_AUTOMATION_BYPASS_SECRET = process.env.VERCEL_AUTOMATION_BYPASS_SECRET

// DynamoDB
export const DYNAMODB_ENDPOINT = process.env.DYNAMODB_ENDPOINT
export const DYNAMODB_API_KEY = process.env.DYNAMODB_API_KEY
